import { Storage } from 'aws-amplify';
import store from '@/store';

// const uuidv4 = require('uuid/v4');

function updateProgress(value) {
  store.commit('files/updateProgress', value);
}

export const uploadFile = async ({ dispatch }, value) => {
  await Storage.put(`uploads/5.${value.name.split('.').pop()}`, value, {
    level: 'private',
    progressCallback: updateProgress,
  });
  dispatch('read');
  return true;
};

export const read = async ({ commit }) => {
  const list = await Storage.list('uploads/', {
    level: 'private',
  });
  const promises = [];
  for (let i = 0; i < list.length; i += 1) {
    promises.push(Storage.get(list[i].key, { level: 'private' }));
  }
  const res = await Promise.all(promises);
  for (let i = 0; i < res.length; i += 1) {
    list[i].url = res[i];
  }
  commit('setAll', list);
  return true;
};

export const remove = async ({ dispatch }, { key }) => {
  await Storage.remove(key, {
    level: 'private',
  });
  dispatch('read');
  return true;
};
